var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCloudLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.61 20.75c-.41 0-.75-.34-.74-.76 0-.41.35-.78.76-.74 1.16 0 2.26-.42 3.11-1.2 1.55-1.36 1.66-3.3 1.24-4.67-.42-1.37-1.59-2.92-3.61-3.18a.753.753 0 0 1-.65-.62c-.39-2.39-1.69-4.04-3.63-4.64-2.02-.62-4.35-.01-5.81 1.52-1.42 1.49-1.75 3.56-.93 5.85a.75.75 0 1 1-1.41.51c-1.01-2.81-.55-5.5 1.26-7.39 1.85-1.93 4.79-2.7 7.34-1.91 2.33.72 3.98 2.64 4.57 5.3 2.04.46 3.67 2 4.32 4.13.71 2.32.07 4.7-1.67 6.22a6.18 6.18 0 0 1-4.11 1.58h-.04z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52 20.75c-2.88-.2-4.19-2.46-4.19-4.47s1.31-4.26 4.19-4.47c.76.01 1.47.16 2.11.48.37.19.51.64.33 1.01-.19.37-.64.51-1.01.33-.42-.22-.9-.32-1.36-.32-1.89.14-2.75 1.59-2.75 2.97 0 1.38.86 2.83 2.79 2.97.41.03.72.39.7.8-.04.4-.37.7-.76.7h-.05zM15.15 10.22a.745.745 0 0 1 .34-1.01c.61-.31 1.3-.48 1.98-.49h.01c.41 0 .74.33.75.74.01.41-.32.76-.74.76-.46.01-.92.12-1.34.33a.59.59 0 0 1-.33.09c-.28 0-.54-.15-.67-.42z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.21 22.55c-.44-.17-.73-.58-.73-1.05v-1.58h-.25c-.75 0-1.02-.44-1.11-.62-.08-.2-.22-.7.27-1.25l2.45-2.79c.31-.35.8-.48 1.24-.31.44.17.73.58.73 1.05v1.58h.25c.74 0 1.02.44 1.11.62.09.18.23.68-.26 1.24l-2.45 2.79c-.23.25-.54.39-.85.39-.13 0-.27-.02-.4-.07zm.02-4.14c.41 0 .75.34.75.75v1.33l1.24-1.41h-.17c-.41 0-.75-.34-.75-.75V17l-1.24 1.41h.17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCloudLightning);
export default __webpack_public_path__ + "static/media/vuesax-outline-cloud-lightning.dae3935333779b15f7ec18efe2039515.svg";
export { ForwardRef as ReactComponent };